module.exports = __webpack_public_path__ + "img/chart-candle-grey.88b4a3dc.svg";